import {
    DEFAULT_PAGE,
    DEFAULT_PAGE_SIZE,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    ORDER_BY,
    ResponseCode
} from "@app/constants/Common";
import { alertMessage, Messages, showMessage } from "@app/constants/Messages";
import { requestCandidates } from "@app/services/CandidateService";
import {
    requestStartRunJob
} from "@app/services/JobService";
import {calculateYearsBetweenDates, convertVNDateTimeToDate} from '@app/utils/DateTimeUtils';
import { doExportExcel } from "@app/utils/CommonUtils";
import CandidateListTable, { CandidateListMode } from "@pages/candidate/list/CandidateListTable";
import { EmailInviteMode } from "@pages/candidate/list/DVTJCUVEmailInviteModal";
import { DVTJCUVAcquireCddPreEmailTabIds, DVTJCUVAcquireCddParentTabIds } from "@pages/dvtjcuv/common/AcquireCddTabs";
import { DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs } from "@pages/dvtjcuv/common/ConnectCddEmpTabs";
import DVTJCUVEmailFollowUpModal from "@pages/dvtjcuv/rundvtjcuv/DVTJCUVEmailFollowUpModal";
import { processRequestCheckDVTJCUVEmailBrief } from "@pages/dvtjcuv/rundvtjcuv/RunDVUtil";
import {
    requestInputBriefEmailDVTJCUV,
    requestInputEmailInviteDVTJCUV,
    requestMoveCddDVTJCUVToTab,
    requestRemoveCandidatesOutDVTJCUVTabs
} from "@pages/dvtjcuv/service/DVTJCUVService";
import React, { useEffect, useState } from 'react';
import { JobFindMode } from "../common/Constant";

const RunDVTJCUVCandidateList = (props) => {
    const [currentTab, setCurrentTab] = useState({});
    const [candidates, setCandidates] = useState([]);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(0);
    const [runJobInfo, setRunJobInfo] = useState({});

    const [showFollowUpModal, setShowFollowUpModal] = useState(false);

    const {runJob, parentTab, requireFilterInputCandidateIs, inputCandidateIds, subTab, onChangeTab} = props
    const [userLoginInfo, setUserLoginInfo] = useState({});

    console.log("RunDVTJCUVCandidateList parent tab:" + JSON.stringify(parentTab))
    console.log("RunDVTJCUVCandidateList sub tab:" + JSON.stringify(subTab))

    const setDisplayCddList = (cdds, sortOption) => {
        const duringNextOneYearItems = []
        const overNextOneYearItems = []
        const otherItems = []
        const currentTime = new Date()
        cdds.forEach((item, index) => {
            item.no = index + 1
            item.hightlight_class = ''
            const jobSeeking = item.job_seeking
            // item.to_do_w_cdd_sort_order = getTodoWCddSortOrder(item);
            if (jobSeeking.current_find_job_mode
                && jobSeeking.current_find_job_mode.toString() === JobFindMode.ON.value.toString()) {
                const noteDateTime = new Date(jobSeeking.last_on_find_job_mode_date_time)
                if (calculateYearsBetweenDates(noteDateTime, currentTime) <= 1) {
                    item.hightlight_class = 'text-danger text-bold'
                    duringNextOneYearItems.push(item);
                } else {
                    item.hightlight_class = 'text-primary'
                    overNextOneYearItems.push(item);
                }
            } else {
                item.hightlight_class = ''
                otherItems.push(item)
            }
        });
        return [
            ...duringNextOneYearItems,
            ...overNextOneYearItems,
            ...otherItems
        ]
    }

    const fetchCandidateList = async (runJobData, pTab, sTab, page, isExportExcel, candidateIds=[]) => {
        const params = {page: page > 0 ? page : DEFAULT_PAGE,
            size: DEFAULT_PAGE_SIZE, order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: {
                run_dvtjcuv_mode: true,
                run_dvtjcuv_id: runJobData ? runJobData.id : runJobInfo.id,
                parent_tab: pTab ? pTab.id : "",
                sub_tab: sTab ? sTab.id : "",
                embedded_job_id: runJobData.embedded_job_id,
                unlimited: true
            }
        }

        if (candidateIds && candidateIds.length > 0) {
            params.search_conditions.candidate_ids = candidateIds;
        } else if (inputCandidateIds && inputCandidateIds.length > 0) {
            params.search_conditions.candidate_ids = inputCandidateIds;
        }

        if (isExportExcel) {
            params.is_export_excel = isExportExcel
        }

        const res = await requestCandidates(params);
        if (isExportExcel) {
            doExportExcel(res.content.candidates)
        }

        let resCandidates = res.content.candidates
        if (parentTab?.id === DVTJCUVAcquireCddParentTabIds.PRE_EMAIL_TAB) {
            if (subTab?.id === DVTJCUVAcquireCddPreEmailTabIds.HOT_JOB_NOT_APPROACHED) {
                // Sắp xếp giảm dần theo các trường:
                // job_seeking.last_on_find_job_mode_date_time (Nếu giá trị null, coi như 0)
                // job_seeking.updated_date_time
                // Thực hiện sắp xếp 
                resCandidates.sort((a, b) => {
                    const aLast = new Date(a.job_seeking.last_on_find_job_mode_date_time || 0).getTime();
                    const bLast = new Date(b.job_seeking.last_on_find_job_mode_date_time || 0).getTime();
                    const aUpdated = new Date(a.job_seeking.updated_date_time).getTime();
                    const bUpdated = new Date(b.job_seeking.updated_date_time).getTime();
                
                    if (bLast !== aLast) {
                        return bLast - aLast;
                    }
                    return bUpdated - aUpdated;
                });
            } else if (subTab?.id === DVTJCUVAcquireCddPreEmailTabIds.TARGETED_TO_EMAIL
                 || subTab?.id === DVTJCUVAcquireCddPreEmailTabIds.TARGETED_NOT_HAVE_EMAIL) {
                    resCandidates = setDisplayCddList(resCandidates)
            }
        }

        setCandidates(resCandidates);
        setAllCandidateIds(res.content.all_candidate_ids);
        setTotalCount(res.content.totalCount)
        setCurrentPage(res.content.page)
        setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
    }

    const onExportExcel = async (candidateIds) => {
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage, true, candidateIds)
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const onEmailFU = async (candidateIds) => {
        // await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage, true)
        setSelectedCandidateIds(candidateIds)
        setShowFollowUpModal(true)
    }

    const onSendEmailInviteJob = async (candidateIds) => {
        // let requestData = {run_job_id: runJobInfo.id, candidate_ids: candidateIds, job_id: runJobInfo.job_id}
        // await requestSendEmailInviteJob(requestData)
        // await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const saveInputJobPipeline = async (candidateId, internalProcess) => {
        // let requestData = {run_job_id: runJobInfo.id, candidate_id: candidateId,
        //     job_id: runJobInfo.job_id, internal_process: internalProcess}
        // const res = await requestSaveJobPipeline(requestData)
        // alertMessage(res.sts_code, false, true)
        // await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const updateCandidatesInSendMails = async (candidateIds, isInSendMails) => {
        // let requestData = {
        //     run_job_id: runJobInfo.id,
        //     candidate_ids: candidateIds,
        //     parent_tab: parentTab,
        //     sub_tab: parentTab.id,
        //     in_send_mails: isInSendMails
        //
        // }
        // await requestUpdateCandidatesInSendMails(requestData)
        // await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const removeCandidateOutTabs = async (tabIds, candidateIds) => {
        let requestData = {run_dvtjcuv_id: runJobInfo.id,
            candidate_ids: candidateIds,
            parent_tab: parentTab.id,
            sub_tabs: tabIds,
        }
        await requestRemoveCandidatesOutDVTJCUVTabs(requestData)
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    const moveCandidatesToTab = async (currentTabId, nextTabId, candidateIds) => {
        let requestData = {
            run_dvtjcuv_id: runJobInfo.id,
            candidate_ids: candidateIds,
            from_parent_tab: parentTab.id,
            to_parent_tab: parentTab.id,
            from_sub_tab: currentTabId,
            to_sub_tab: nextTabId,
        }
        await requestMoveCddDVTJCUVToTab(requestData)
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }


    const onInputEmailInputDVTJCUV = async (candidateIds, inviteMode) => {
        let isSuccess = false
        if (inviteMode === EmailInviteMode.INVITE_EMAIL_DN_UPDATE_INFO) {
            const res = await requestInputBriefEmailDVTJCUV({
                receiver_ids: candidateIds,
                parent_tab: parentTab.id,
                sub_tab: subTab.id,
                invite_mode: inviteMode
            })
            isSuccess = res.sts_code === ResponseCode.SUCCESS
        } else {
            const res = await requestInputEmailInviteDVTJCUV({
                candidate_ids: candidateIds,
                parent_tab: parentTab.id,
                sub_tab: subTab.id,
                invite_mode: inviteMode
            })
            isSuccess = res.sts_code === ResponseCode.SUCCESS
        }


        if (isSuccess) {
            await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
        }
    }

    const onNextPage = async (page, searchOrderBy) => {
        await fetchCandidateList(runJobInfo, parentTab, subTab, page)
    }

    const onEmbeddedIntoJob = async (jobId) => {
        runJobInfo.embedded_job_id = jobId
        await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage)
    }

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    useEffect(() => {
        if (subTab) {
            setCurrentTab({...subTab})
        }
        if (runJob) {
            setRunJobInfo({...runJob})
            if (!requireFilterInputCandidateIs || (requireFilterInputCandidateIs && inputCandidateIds && inputCandidateIds.length > 0))
            fetchCandidateList(runJob, parentTab, subTab, inputCandidateIds).then()
        }

    }, [runJob, parentTab, subTab, inputCandidateIds]);

    const reMailInviteJob = async (candidateIds, internalProcess) => {
        const res = await requestStartRunJob({candidate_ids: candidateIds, job_id: runJobInfo.job_id, internal_process: internalProcess});

        if (res.sts_code !== ResponseCode.SUCCESS) {
            alertMessage(res.sts_code, false, true)
        } else {
            const newUpdateRunJob = res.content
            setRunJobInfo({...newUpdateRunJob})
            // setMailTabData({...newUpdateRunJob[parentTab.id]})
            fetchCandidateList(newUpdateRunJob, parentTab, subTab).then()
            showMessage(Messages.processSuccess, false, true)
        }
    }

    const onStartCheckSendBriefEmailDVTJCUV = async (condition = {}) => {
        condition.receiver_ids = condition.receiver_ids || []
        const result = await processRequestCheckDVTJCUVEmailBrief(condition)
        if (result) {
            if (onChangeTab) {
                onChangeTab(DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs.SEND_EMAIL_TAB)
            } else {
                await fetchCandidateList(runJob, parentTab, subTab)
            }
        }
    }

    return (
        <>
            <CandidateListTable candidates={candidates}
                                allCandidateIds={allCandidateIds}
                                totalCount={totalCount}
                                noPagination
                                showBtnSelect
                                onExportExcel={onExportExcel}
                                onEmailFU={onEmailFU}
                                onSendEmailDVTJCUV={onSendEmailInviteJob}
                                onSendBriefEmailDVTJCUV={onStartCheckSendBriefEmailDVTJCUV}
                                // saveInputJobPipeline={saveInputJobPipeline}
                                mode={CandidateListMode.DVTJCUV}
                                mailInviteJobTab={currentTab}
                                parentTab={parentTab}
                                subTab={subTab}
                                // updateCandidatesInSendMails={updateCandidatesInSendMails}
                                removeCandidateOutTabs={removeCandidateOutTabs}
                                moveCandidatesToTab={moveCandidatesToTab}
                                onInputEmailInputDVTJCUV={onInputEmailInputDVTJCUV}
                                // onEmbeddedIntoJob={onEmbeddedIntoJob}
                                // onReMailInviteJob={(candidateIds, internalProcess) => reMailInviteJob(candidateIds, internalProcess)}
                                onSearchCandidates={(page, searchOrderBy) => onNextPage(page, searchOrderBy)}
            />


            {showFollowUpModal &&
            <DVTJCUVEmailFollowUpModal candidateIds={selectedCandidateIds}
                                     onClose={() => setShowFollowUpModal(false)}
                                     isShow={showFollowUpModal}/>
            }
        </>
    )
}

export default RunDVTJCUVCandidateList;
